import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/fearGreed/createItem";
import validator from "@validators/Clients/WhaleShark/fearGreed/fearGreed.validate";
import formMapper from "@mappers/Clients/WhaleShark/fearGreed/CreateFearGreed.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
